/**
 * <Comente>
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.Seconds = (function () {

    function Seconds () {

        Monet.UI.Fields.TextField.apply(this, arguments);

        this.createBaseStructure();

        this.createElement = function () {

            this.input = document.createElement('input');
            this.input.type = 'text';
            this.input.maxLength = this.maxSize;

            this.input.className = 'MonetUIFieldSeconds';
            this.rootEl.appendChild(this.input, this.label);

        };

        this.setInputValue = function(){

            if(this.input){


                var valueFormatted = this.value;

                if (typeof this.value === 'number') {
                    valueFormatted = new Monet.Format.SECONDS(this.value).convertSecondsToHourMinutesSeconds().getValue();
                }

                this.input.value = valueFormatted;
            }
        };

        this.getValue = function () {
            if(this.input){
                this.value = this.input.value;
            }

            if(this.value){
                return new Monet.Format.SECONDS(this.value).convertHourToSeconds().getValue();
            } else {
                return this.value;
            }
        };

        this.addListeners = function () {

            var title = Monet.I18n.getResourcesByKey("Greenmile.TimePicker.Title");

            $(this.input).timepicker({
                hourGrid: 4,
                minuteGrid: 10,
                secondGrid: 10,
                timeFormat: new Monet.Date.GeneralFunctions().getTimeFormatWithSeconds(),
                timeOnlyTitle: title,
                beforeShow: () => {
                    $('main').append($('#ui-datepicker-div'));
                }
            });

        };

        this.render = function () {

            this.setMaxSize(8);
            this.createElement();
            this.addListeners();
            return this.rootEl;

        };

    }

    return Seconds;

}());